module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_1@3x.1b068a61.png";